import clsx from "clsx"
import { forwardRef } from "react"

const TreeIllustration = forwardRef(function TreeIllustration({ className = '' }, ref) {
  return (
    <svg ref={ref} className={clsx(className, 'w-full h-auto')} width="204" height="171" viewBox="0 0 204 171" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M91.1992 57L91.1992 77.4286C91.1992 85.5594 97.7906 92.1507 105.921 92.1507L146.778 92.1507C154.909 92.1507 161.501 98.7421 161.501 106.873L161.501 122.551" stroke="#FF5E00" strokeWidth="1.91169"/>
      <path d="M91.1992 57L91.1992 77.4286C91.1992 85.5594 84.6079 92.1507 76.4771 92.1507L35.6199 92.1507C27.4891 92.1507 20.8978 98.7421 20.8978 106.873L20.8978 122.551" stroke="#FF5E00" strokeWidth="1.91169"/>
      <path d="M171.951 28.4956L106.4 28.4956" stroke="#FF5E00" strokeWidth="1.91169"/>
      <rect x="70.2979" width="41.8008" height="57.0012" rx="3.39742" fill="#FF5E00"/>
      <rect x="70.2979" y="113.999" width="41.8008" height="57.0012" rx="3.39742" fill="#FF5E00"/>
      <rect y="113.999" width="41.8008" height="57.0012" rx="3.39742" fill="#FF5E00"/>
      <rect x="140.599" y="113.999" width="41.8008" height="57.0012" rx="3.39742" fill="#FF5E00"/>
      <rect x="161.495" width="41.8008" height="57.0012" rx="3.39742" fill="#FF5E00"/>
      <path d="M91.1992 74.1006V141.552" stroke="#FF5E00" strokeWidth="1.91169"/>
    </svg>
  )
})

export default TreeIllustration
